export default function formatDate(date) {
  return isNaN(date) ? new Date(date || 0) : new Date(Number(date || 0));
}
